export default "__VITE_ASSET__282ef56f__"